// extracted by css-extract-rspack-plugin
export default {"container":"product-detail-fragment__ReviewsStarsRating_container__-fY1y"};